import { useEffect, useState } from "react";

/**
 * Hook, který vrací boolean hodnotu, která říká, jestli prohližeč už načetl všechny fonty.
 * Hodí se např. při měření rozměrů HTML komponent. Využívá události `document.fonts.ready()`, aby
 * bylo zajištěno, že prohlížeč už načetl všechny fonty.
 */
export const useFontsLoaded = () => {
    const [fontLoaded, setFontLoaded] = useState(document.fonts.status === "loaded");
    useEffect(() => {
        if (!fontLoaded) {
            document.fonts.ready.then(() => {
                setFontLoaded(true);
            });
        }
    }, [fontLoaded]);
    return fontLoaded;
};
